import { createAction } from 'typesafe-actions'

export const setActiveSection = createAction('SET_ACTIVE_SECTION')<number>()
